
<template>
  <div class="wh100">
    <MyLayout title="污水处理厂信息" style="background:#fff" content-style="background:#eee;">
      <template slot="icon">
        <i class="el-icon-setting" style="color:#409EFF;font-size:20px;font-weight:bold;"></i>
      </template>
      <template slot="filter">
        <el-form ref="form" :model="form" :inline="true" size="medium">
          <el-form-item>
            <el-input v-model="form.key" placeholder="请输入关键词"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="queryData">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-document-add" @click="importExcel">添加</el-button>
          </el-form-item>
          <input
            type="file"
            ref="uploadExcel"
            v-show="false"
            accept=".xls, .xlsx"
            @change="readExcel"
          />
          <el-form-item>
            <el-button type="primary" icon="el-icon-download" @click="ExportExcel">下载模板</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-document-delete" @click="delData">删除</el-button>
          </el-form-item>
        </el-form>
      </template>
      <template slot="content">
        <MyTable
          :url="tableUrl"
          :params="form"
          ref="myTable"
          :default-sort="{prop: 'StationName', order: 'descending'}"
          :customSort="true"
          :index-column="true"
          :checked-column="true"
          border
          fit
          @selection-change="tableSelected"
        >
          <template slot="columns">
            <el-table-column prop="SewageName" label="单位名称" align="center" sortable></el-table-column>
            <el-table-column prop="SewageAddress" label="企业详细地址" align="center" sortable></el-table-column>
            <el-table-column prop="Longitude" label="经度" width="100" align="center" sortable></el-table-column>
            <el-table-column prop="Latitude" label="纬度" width="100" align="center" sortable></el-table-column>
            <el-table-column prop="SewageType" label="污水处理设施类型" width="150" align="center" sortable></el-table-column>
            <el-table-column prop="CompletionTime" label="建成时间" width="100"  align="center" sortable></el-table-column>

          </template>
        </MyTable>
      </template>
    </MyLayout>
  </div>
</template>
<script>
import MyLayout from "../../components/layout/LayoutTopFilter";
import MyPanel from "../../components/Pannel/Pannel";
import MyTable from "../../components/PageTable";
export default {
  components: {
    MyLayout,
    MyPanel,
    MyTable,
  },
  data() {
    return {
      fullscreenLoading: false,
      loading: false,
      form: {
        key: "",
      },
      selectedItems: [],
      tableUrl: "/DataManage/GetSewage_Page",
      optionsRiver: [],
      optionsBy: [],
    };
  },
  created() {},
  methods: {
    queryData() {
      let that = this;
      debugger;
      that.$refs["form"].validate((valid) => {
        debugger;
        if (valid) {
          that.$refs.myTable.reload();
        }
      });
    },
    tableSelected(val) {
      this.selectedItems = val;
    },
    delData() {
      let that = this;
      if (that.selectedItems.length == 0) {
        that.$message.warning("请选择要删除的数据");
        return;
      }

      that
        .$confirm("确定要删除这些数据吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          that.$api.post(
            "/DataManage/DelStation",
            that.selectedItems,
            function (res) {
              debugger;
              if (res.code == 200) {
                that.queryData();
                that.$message.success("删除成功");
              } else {
                that.$message.error("删除失败");
              }
            }
          );
        });
    },
    ExportExcel() {
      let that = this;

      this.$refs["form"].validate((valid) => {
        if (valid) {
          that.fullscreenLoading = true;
          that.$api.downloadFile(
            "GET",
            "/DataManage/TemplateDownload",
            {
              TemplateName: "污水处理厂信息表导入模板.xlsx",
              FilePath: "\\UploadFiles\\TemplateExcel\\",
            },
            function (res) {
              that.fullscreenLoading = false;
            },
            function () {
              that.fullscreenLoading = false;
            }
          );
        }
      });
    },importExcel() {
      this.$refs.uploadExcel.click();
    },
    readExcel(e) {
      const files = e.target.files;
      let _this = this;
      debugger;
      if (files.length <= 0) {
        //如果没有文件名
        return false;
      }
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          debugger;
          const data = ev.target.result;
          const workbook = _this.XLSX.read(data, {
            type: "binary",
          });
          const wsname = workbook.SheetNames[0]; //取第一张表
          const ws = _this.XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); //获取到XLSX表格中的数据,并生成json格式的数据类型
          // console.log(ws,666);
          let arr = [];
          ws.forEach((value, index, ws) => {
            arr.push({
              SewageName: ws[index]["单位名称"] + "",
              SewageAddress: ws[index]["企业详细地址"] + "",
              Longitude: ws[index]["经度"] + "",
              Latitude: ws[index]["纬度"] + "",
              SewageType: ws[index]["污水处理设施类型"] + "",
              CompletionTime: ws[index]["建成时间"] + "",
            });
          });
          for (let i in arr) {
            let item = arr[i];
            for (let key in item) {
              if (item[key] == "undefined") {
                delete item[key];
              }
            }
          }
          this.importExcelData(arr);
        } catch (e) {
          return false;
        }
      };
      fileReader.readAsBinaryString(files[0]);
    },
    importExcelData(arrList) {
      let _this = this;
      this.$api.post("/DataManage/AddSewage", arrList, function (res) {
        debugger;
        if (res.code == 200) {
          _this.queryData();
          _this.$message.success("添加成功");
        } else {
          _this.$message.error("添加失败");
        }
        _this.$refs.uploadExcel.value = ""; //把之前导入的清空
      });
    },
  },
  mounted() {
  },
  computed: {},
  watch: {},
};
</script>
<style lang="less" scoped>
.el-form-item {
  margin-bottom: 15px;
}
/deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
}
.el-scrollbar .is-horizontal {
  display: none;
}
.my-tabs {
  display: flex;
  flex-direction: column;
}
.my-checkbox {
  margin-bottom: 10px;
}
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: unset;
}
/deep/.el-tabs__content {
  flex: 1;
}
</style>